<template>
  <div id="SetupUserInfo">
    <!-- ヘッダー -->
    <Header
      headerTitle="ユーザー情報を入力"
      :isShowPrevious="false"
      :isShowClose="false"
    />
    <!-- ボディ -->
    <div class="mx-6 pb-8">
      <!-- 入力フォーム -->
      <div class="text-left mt-6 mb-6">
        <div class="mb-5">
          <div class="text-W7 text-[13px] leading-[13px] mb-2">お名前</div>
          <div class="flex">
            <TextFormWithValidation
              ref="FamilyNameForm"
              class="w-1/2"
              inputClass="bg-gray200 border-gray200"
              :text="userInfo.myoji"
              :validationType="['required']"
              maxlength="100"
              placeholder="東海"
              errorMessage="苗字を入力してください。"
              @input-text="userInfo.myoji = $event"
            />
            <TextFormWithValidation
              ref="FirstNameForm"
              class="w-1/2 ml-1.5"
              inputClass="bg-gray200 border-gray200"
              :text="userInfo.na"
              :validationType="['required']"
              maxlength="100"
              placeholder="太郎"
              errorMessage="名前を入力してください。"
              @input-text="userInfo.na = $event"
            />
          </div>
        </div>
        <div class="mb-5">
          <div class="text-W7 text-[13px] leading-[13px] mb-2">性別</div>
          <div class="w-full flex flex-row justify-between">
            <FormRadioButton
              v-for="genderObj in GENDER_LIST"
              :key="genderObj.key"
              :itemKey="genderObj.key"
              :label="genderObj.label"
              v-model="userInfo.gender"
              class="mr-2 last:mr-0"
            />
          </div>
        </div>
        <div class="mb-5">
          <div class="flex mb-2 flex-row items-end">
            <div class="text-W7 text-[13px] leading-[13px]">生年月日</div>
            <div class="text-W4 text-gray400 text-[11px] leading-[11px]">
              （1980年1月1日の場合：19800101）
            </div>
          </div>
          <TextFormWithValidation
            ref="BirthdayForm"
            inputClass="bg-gray200 border-gray200"
            :text="userInfo.birthday"
            inputmode="numeric"
            :validationType="['required', 'birthday']"
            maxlength="10"
            placeholder="19800101"
            errorMessage="正しい生年月日を入力してください。"
            @input-text="userInfo.birthday = $event"
            @focus="userInfo.birthday = removeSlash($event)"
            @blur="userInfo.birthday = convertBirthdaySlashFormat($event)"
          />
        </div>
        <div class="mb-5">
          <div class="text-W7 text-[13px] leading-[13px] mb-2">住所</div>
          <TextFormWithValidation
            ref="AddressForm"
            inputClass="bg-gray200 border-gray200"
            :text="userInfo.address"
            :validationType="['required']"
            maxlength="100"
            placeholder="東京都千代田区丸の内 1-1-1 東海ビル101"
            errorMessage="正しい住所を入力してください。"
            @input-text="userInfo.address = $event"
          />
        </div>
        <div class="mb-5">
          <div class="text-W7 text-[13px] leading-[13px] mb-2">電話番号</div>
          <TextFormWithValidation
            ref="TelForm"
            inputClass="bg-gray200 border-gray200"
            :text="userInfo.tel"
            inputmode="numeric"
            :validationType="['required', 'tel']"
            maxlength="100"
            placeholder="07000123456"
            errorMessage="正しい電話番号を入力してください。"
            @input-text="userInfo.tel = $event"
          />
        </div>
        <div>
          <div class="mb-2 flex flex-row items-end">
            <div class="text-W7 text-[13px] leading-[13px]">メールアドレス</div>
            <div class="text-W4 text-gray400 text-[11px] leading-[11px]">
              （編集不可）
            </div>
          </div>
          <TextForm
            :text="userInfo.email"
            :isBackButton="false"
            inputClass="bg-gray200 border-gray200 !text-gray400"
            :isDisabled="true"
          />
        </div>
      </div>
      <!-- 登録ボタン -->
      <TheButton
        text="登録する"
        :isDisabled="isEntryError()"
        @click-button="onClickRegisterButton()"
      />
    </div>
    <!-- ユーザー情報登録失敗時ポップアップ -->
    <Modal
      v-if="isShowSetupUserInfoFailedModal"
      :isShowCloseButton="false"
      :isModalCenter="true"
      modalPaddingX="20px"
    >
      <div class="px-5 pt-8 pb-6">
        <div class="text-W5 font-semibold text-[17px] leading-[25.5px]">
          エラーが発生しました。
        </div>
        <div class="mt-3 mx-5 text-W3 text-[15px] leading-[23px]">
          通信環境をご確認いただくか、時間を置いて再度お試しください。
        </div>
        <div
          class="mt-5 py-4 the-button-default text-W7 text-[15px] leading-[15px]"
          @click="isShowSetupUserInfoFailedModal = false"
        >
          もどる
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
/**
 * ユーザー情報登録画面
 */
import Header from '@/components/organisms/Header.vue'
import Modal from '@/components/Modal.vue'
import TheButton from '@/components/atoms/TheButton.vue'
import FormRadioButton from '@/components/atoms/FormRadioButton.vue'
import TextFormWithValidation from '@/components/molecules/TextFormWithValidation.vue'
import TextForm from '@/components/TextForm.vue'
import Util from '@/mixins/util.js'
import NativeUtil from '@/mixins/nativeUtil.js'
import {getAuth0EmailAddress} from '@/auth/AuthorizationInteractor.js'
import {navigateTo} from '@/router'

const SetupUserInfo = {
  name: 'SetupUserInfo',
  components: {
    Header,
    Modal,
    TheButton,
    FormRadioButton,
    TextFormWithValidation,
    TextForm,
  },
  mixins: [Util, NativeUtil],
  data() {
    return {
      userInfo: {...this.$store.state.user.info, email: getAuth0EmailAddress()}, // ユーザー情報
      GENDER_LIST: [
        this.$config.GENDER.MAN,
        this.$config.GENDER.WOMAN,
        this.$config.GENDER.NO_SELECT,
      ], // 性別選択リスト
      isShowSetupUserInfoFailedModal: false, // ユーザー情報登録失敗ポップアップ
    }
  },
  mounted() {
    // 初回にバリデーションを走らせるため、DOMを強制的に再描画
    this.$forceUpdate()
  },
  methods: {
    /**
     * 入力フォームが一つでもエラーであるかどうか
     */
    isEntryError() {
      if (
        this.isNull(this.$refs.FamilyNameForm) ||
        this.isNull(this.$refs.FirstNameForm) ||
        this.isNull(this.$refs.BirthdayForm) ||
        this.isNull(this.$refs.AddressForm) ||
        this.isNull(this.$refs.TelForm)
      ) {
        return true
      }

      return (
        this.$refs.FamilyNameForm.isInvalid ||
        this.$refs.FirstNameForm.isInvalid ||
        this.$refs.BirthdayForm.isInvalid ||
        this.$refs.AddressForm.isInvalid ||
        this.$refs.TelForm.isInvalid
      )
    },
    /**
     * 登録するボタン押下時の処理
     */
    onClickRegisterButton() {
      // 成功時
      const success = () => {
        this.$store.commit('endLoading')
        // ユーザー情報登録完了画面へ遷移
        navigateTo({name: this.$config.DISPLAY_SETUP_USER_INFO_FINISHED})
      }

      // 失敗時
      const failed = () => {
        this.$store.commit('endLoading')
        // ユーザー情報登録失敗ポップアップ表示
        this.isShowSetupUserInfoFailedModal = true
      }

      // ユーザー情報更新API実行
      this.$store.commit('startLoading')
      this.$store.dispatch('updateUser', {
        success: success,
        failed: failed,
        userInfo: this.userInfo,
      })
    },
    /**
     * 生年月日入力中のスラッシュ表示
     * 入力状況状況によって、スラッシュの出力が変わる
     * パターン1: 2025まで入力 => 「2025」と表示
     * パターン2: 20250まで入力 => 「2025/0」と表示
     * パターン3: 2025051まで入力 => 「2025/05/1」と表示
     * @param {string} birthDayStr YYYYMMDD形式の生年月日
     * @returns YYYY/MM/DD形式の生年月日
     */
    convertBirthdaySlashFormat(birthDayStr) {
      let birthday = birthDayStr
      birthday = birthday.replace(/\D/g, '')
      const yearAndMonthSeparateNum = 4
      const daySeparateNum = 7
      const firstString = 0

      // パターン2
      if (yearAndMonthSeparateNum < birthday.length) {
        const year = birthday.substring(firstString, yearAndMonthSeparateNum) // 「YYYY」を出力
        const monthDay = birthday.substring(yearAndMonthSeparateNum) // 「MM/DD」を出力
        birthday = `${year}/${monthDay}`
      }

      // パターン3
      if (daySeparateNum < birthday.length) {
        const firstDayString = 0
        const unNecessaryString = 2
        const yearMonth = birthday.slice(firstString, daySeparateNum) // 「YYYY/MM」を出力
        const day = birthday
          .substring(daySeparateNum)
          .substring(firstDayString, unNecessaryString) // 「DD」を出力、DD日以降不要なデータがあれば削除(ペースト対策)
        birthday = `${yearMonth}/${day}`
      }
      return birthday
    },
    /**
     * スラッシュ除去
     * @param {string} birthDayStr YYYY/MM/DD形式の生年月日
     * @returns YYYYMMDD形式の生年月日
     */
    removeSlash(birthDayStr) {
      return birthDayStr.replace(/\D/g, '')
    },
  },
}
export default SetupUserInfo
</script>

<style scoped></style>
